import { LoadingState } from "@material-dev/insights-portal-ui-components/lib/types";
import { TextVariableDto } from "app/ApiClient";

export interface TextVariablesState {
  textVariables: TextVariableDto[],
  loadingTextVariables: LoadingState,
  loadingTextVariablesError?: string,
  waveVariables: string[],
  loadingWaveVariables: LoadingState,
  loadingWaveVariablesError?: string,
  filters?: { [key in keyof TextVariableDto]: string[] };
  allTextVariables: TextVariableDto[];
}
export const initialTextVariables: TextVariablesState = {
  textVariables: [],
  loadingTextVariables: LoadingState.idle,
  waveVariables: [],
  loadingWaveVariables: LoadingState.idle,
  allTextVariables: [],
};
